$.widget.bridge('uibutton', $.ui.button);






// WEBPACK FOOTER //
// src/assets/js/conflict-resolver.js